<template>
  <div :class="getFlagClassName()"></div>
</template>
<script>
export default {
  props: ['code'],
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    getFlagClassName() {
      const json = {
        // 中国: 'CN',
        美国: 'AA',
        安道尔: 'AD',
        阿拉伯联合酋长国: 'AE',
        阿富汗: 'AF',
        安提瓜和巴布达: 'AG',
        阿尔巴尼亚: 'AL',
        亚美尼亚: 'AM',
        安哥拉: 'AO',
        阿根廷: 'AR',
        奥地利: 'AT',
        澳大利亚: 'AU',
        阿鲁巴岛: 'AW',
        阿塞拜疆: 'AZ',
        波斯尼亚和黑塞哥维那: 'BA',
        巴巴多斯: 'BB',
        孟加拉国: 'BD',
        比利时: 'BE',
        布基纳法索: 'BF',
        保加利亚: 'BG',
        巴林: 'BH',
        布隆迪: 'BI',
        贝宁: 'BJ',
        百慕大: 'BM',
        文莱: 'BN',
        玻利维亚: 'BO',
        巴西: 'BR',
        巴哈马: 'BS',
        不丹: 'BT',
        博茨瓦纳: 'BW',
        白俄罗斯: 'BY',
        伯利兹: 'BZ',
        加拿大: 'CA',
        刚果民主共和国: 'CG',
        中非共和国: 'CF',
        瑞士: 'CH',
        智利: 'CL',
        喀麦隆: 'CM',
        哥伦比亚: 'CO',
        哥斯达黎加: 'CR',
        古巴: 'CU',
        佛得角: 'CV',
        塞浦路斯: 'CY',
        捷克共和国: 'CZ',
        德国: 'DE',
        吉布提: 'DJ',
        丹麦: 'DK',
        多米尼克: 'DM',
        多明尼加共和国: 'DO',
        阿尔及利亚: 'DZ',
        厄瓜多尔: 'EC',
        爱沙尼亚: 'EE',
        埃及: 'EG',
        厄立特里亚: 'ER',
        西班牙: 'ES',
        埃塞俄比亚: 'ET',
        芬兰: 'FI',
        斐济: 'FJ',
        福克兰群岛: 'FK',
        密克罗尼西亚: 'FM',
        法罗群岛: 'FO',
        法国: 'FR',
        加蓬: 'GA',
        英国: 'GB',
        格林纳达: 'GD',
        乔治亚州: 'GE',
        加纳: 'GH',
        直布罗陀: 'GI',
        冈比亚: 'GM',
        几内亚: 'GN',
        赤道几内亚: 'GQ',
        希腊: 'GR',
        危地马拉: 'GT',
        几内亚比绍: 'GW',
        圭亚那: 'GY',
        洪都拉斯: 'HN',
        克罗地亚: 'HR',
        海地: 'HT',
        匈牙利: 'HU',
        印度尼西亚: 'ID',
        爱尔兰: 'IE',
        以色列: 'IL',
        印度: 'IN',
        伊拉克: 'IQ',
        伊朗: 'IR',
        冰岛: 'IS',
        意大利: 'IT',
        牙买加: 'JM',
        约旦: 'JO',
        日本: 'JP',
        肯尼亚: 'KE',
        吉尔吉斯斯坦: 'KG',
        柬埔寨: 'KH',
        基里巴斯: 'KI',
        科摩罗: 'KM',
        圣基茨和尼维斯: 'KN',
        北朝鲜: 'KP',
        韩国: 'KR',
        科威特: 'KW',
        开曼群岛: 'KY',
        哈萨克斯坦: 'KZ',
        老挝: 'LA',
        黎巴嫩: 'LB',
        圣卢西亚: 'LC',
        列支敦士登: 'LI',
        斯里兰卡: 'LK',
        利比里亚: 'LR',
        莱索托: 'LS',
        立陶宛: 'LT',
        卢森堡: 'LU',
        拉脱维亚: 'LV',
        利比亚: 'LY',
        摩洛哥: 'MA',
        摩纳哥: 'MC',
        摩尔达维亚: 'MD',
        黑山: 'ME',
        马达加斯加: 'MG',
        马其顿: 'MK',
        缅甸: 'MM',
        蒙古: 'MN',
        毛里塔尼亚: 'MR',
        马耳他: 'MT',
        毛里求斯: 'MU',
        马尔代夫: 'MV',
        马拉维: 'MW',
        墨西哥: 'MX',
        马来西亚: 'MY',
        莫桑比克: 'MZ',
        纳米比亚: 'NA',
        尼日尔: 'NE',
        尼日利亚: 'NG',
        尼加拉瓜: 'NI',
        荷兰: 'NL',
        挪威: 'NO',
        尼泊尔: 'NP',
        瑙鲁: 'NR',
        新西兰: 'NZ',
        阿曼: 'OM',
        巴拿马: 'PA',
        秘鲁: 'PE',
        巴布亚新几内亚: 'PG',
        菲律宾: 'PH',
        巴基斯坦: 'PK',
        波兰: 'PL',
        波多黎各: 'PR',
        巴勒斯坦: 'PS',
        葡萄牙: 'PT',
        帕劳: 'PW',
        巴拉圭: 'PY',
        卡塔尔: 'QA',
        罗马尼亚: 'RO',
        塞尔维亚: 'RS',
        俄罗斯: 'RU',
        卢旺达: 'RW',
        沙特阿拉伯: 'SA',
        所罗门群岛: 'SB',
        塞舌尔: 'SC',
        瑞典: 'SE',
        新加坡: 'SG',
        斯洛文尼亚: 'SI',
        斯洛伐克共和国: 'SK',
        塞拉利昂: 'SL',
        圣马力诺: 'SM',
        塞内加尔: 'SN',
        索马里: 'SO',
        苏里南: 'SR',
        圣多美和普林西比: 'ST',
        救星: 'SV',
        叙利亚: 'SY',
        斯威士兰: 'SZ',
        乍得: 'TD',
        多哥: 'TG',
        泰国: 'TH',
        塔吉克斯坦: 'TJ',
        土库曼斯坦: 'TM',
        突尼斯: 'TN',
        汤加: 'TO',
        土耳其: 'TR',
        特立尼达和多巴哥: 'TT',
        图瓦卢: 'TV',
        坦桑尼亚: 'TZ',
        乌克兰: 'UA',
        乌干达: 'UG',
        乌拉圭: 'UY',
        乌兹别克斯坦: 'UZ',
        圣文森特和格林纳丁: 'VC',
        委内瑞拉: 'VE',
        英属维尔京群岛: 'VG',
        越南: 'VN',
        瓦努阿图: 'VU',
        瓦利斯和富图纳: 'WF',
        西萨摩亚: 'WS',
        南非: 'ZA',
        赞比亚: 'ZM',
        津巴布韦: 'ZW',
      };
      const jsonCode = {
        '+86': 'CN',
        '+1': 'AA',
        '+1340': 'AA',
        '+376': 'AD',
        '+971': 'AE',
        '+93': 'AF',
        '+1268': 'AG',
        '+355': 'AL',
        '+374': 'AM',
        '+244': 'AO',
        '+54': 'AR',
        '+43': 'AT',
        '+61': 'AU',
        '+994': 'AZ',
        '+387': 'BA',
        '+1246': 'BB',
        '+880': 'BD',
        '+32': 'BE',
        '+226': 'BF',
        '+359': 'BG',
        '+973': 'BH',
        '+257': 'BI',
        '+229': 'BJ',
        '+1441': 'BM',
        '+673': 'BN',
        '+591': 'BO',
        '+55': 'BR',
        '+1242': 'BS',
        '+975': 'BT',
        '+267': 'BW',
        '+375': 'BY',
        '+501': 'BZ',
        '+243': 'CG',
        '+236': 'CF',
        '+41': 'CH',
        '+56': 'CL',
        '+237': 'CM',
        '+57': 'CO',
        '+506': 'CR',
        '+53': 'CU',
        '+238': 'CV',
        '+357': 'CY',
        '+49': 'DE',
        '+253': 'DJ',
        '+45': 'DK',
        '+1767': 'DM',
        '+213': 'DZ',
        '+593': 'EC',
        '+372': 'EE',
        '+20': 'EG',
        '+34': 'ES',
        '+251': 'ET',
        '+358': 'FI',
        '+679': 'FJ',
        '+500': 'FK',
        '+691': 'FM',
        '+298': 'FO',
        '+33': 'FR',
        '+241': 'GA',
        '+1284': 'GB',
        '+44': 'GB',
        '+1473': 'GD',
        '+233': 'GH',
        '+350': 'GI',
        '+220': 'GM',
        '+675': 'PG',
        '+240': 'GQ',
        '+224': 'GN',
        '+245': 'GW',
        '+30': 'GR',
        '+502': 'GT',
        '+594': 'GY',
        '+592': 'GY',
        '+504': 'HN',
        '+385': 'HR',
        '+509': 'HT',
        '+36': 'HU',
        '+62': 'ID',
        '+353': 'IE',
        '+972': 'IL',
        '+91': 'IN',
        '+964': 'IQ',
        '+98': 'IR',
        '+354': 'IS',
        '+39': 'IT',
        '+1876': 'JM',
        '+962': 'JO',
        '+81': 'JP',
        '+254': 'KE',
        '+855': 'KH',
        '+269': 'KM',
        '+1869': 'KN',
        '+82': 'KR',
        '+965': 'KW',
        '+1345': 'KY',
        '+856': 'LA',
        '+961': 'LB',
        '+1758': 'LC',
        '+423': 'LI',
        '+94': 'LK',
        '+231': 'LR',
        '+266': 'LS',
        '+370': 'LT',
        '+352': 'LU',
        '+371': 'LV',
        '+218': 'LY',
        '+212': 'MA',
        '+377': 'MC',
        '+382': 'ME',
        '+261': 'MG',
        '+389': 'MK',
        '+95': 'MM',
        '+976': 'MN',
        '+222': 'MR',
        '+230': 'MU',
        '+960': 'MV',
        '+265': 'MW',
        '+52': 'MX',
        '+60': 'MY',
        '+258': 'MZ',
        '+227': 'NE',
        '+234': 'NG',
        '+505': 'NI',
        '+31': 'NL',
        '+47': 'NO',
        '+977': 'NP',
        '+674': 'NR',
        '+64': 'NZ',
        '+968': 'OM',
        '+507': 'PA',
        '+51': 'PE',
        '+63': 'PH',
        '+92': 'PK',
        '+48': 'PL',
        '+1787': 'PR',
        '+970': 'PS',
        '+351': 'PT',
        '+595': 'PY',
        '+974': 'QA',
        '+40': 'RO',
        '+381': 'RS',
        // '+7': 'RU',
        '+250': 'RW',
        '+966': 'SA',
        '+248': 'SC',
        '+46': 'SE',
        '+65': 'SG',
        '+386': 'SI',
        '+232': 'SL',
        '+378': 'SM',
        '+221': 'SN',
        '+252': 'SO',
        '+597': 'SR',
        '+239': 'ST',
        '+963': 'SY',
        '+268': 'SZ',
        '+235': 'TD',
        '+228': 'TG',
        '+66': 'TH',
        '+216': 'TN',
        '+676': 'TO',
        '+90': 'TR',
        '+1868': 'TT',
        '+255': 'TZ',
        '+380': 'UA',
        '+256': 'UG',
        '+598': 'UY',
        '+998': 'UZ',
        '+1784': 'VC',
        '+58': 'VE',
        '+84': 'VN',
        '+678': 'VU',
        '+27': 'ZA',
        '+260': 'ZM',
        '+263': 'ZW',
      };
      if (this.code === '+853') {
        return 'flag ' + 'CN';
      } else if (this.code === '+852') {
        return 'flag  ' + 'CN';
      } else if (this.code === '+886') {
        // 去掉台湾国旗
        return 'noFlag';
        // return 'flag  ' + 'CN';
      } else if (!jsonCode[this.code]) {
        return 'noFlag';
      } else {
        return 'flag ' + jsonCode[this.code];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.noFlag {
  display: none;
}
.flag {
  margin-right: 0.28rem;
  // width: 38px;
  // height: 26px;
  scale: 0.8;

  background: url('https://res.miaocode.com/zhanghongjie/sprite-1649906764960.png') no-repeat top left;
  width: 32px;
  height: 32px;
  display: inline-block;
  background-position: 0 30px;
}
.Countryselect {
  position: absolute;
  width: 100%;
  height: 100%;
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
  }
  &-inner {
    z-index: 9998;
    overflow-y: auto;
    height: 85%;
    position: fixed;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    border-radius: 0.9375rem 0.9375rem 0 0;
    background-color: #f5f5f5;
    text-align: center;
    font-size: 1rem;
    .Countrylist {
      background: white;
      padding: 0 1rem;
      .countrycode-item {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #e4e4e4;

        .itemName {
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .top {
    padding: 0 1rem;
    position: relative;
    margin-bottom: 0.625rem;
    img {
      position: absolute;
      height: 1.4rem;
      top: 50%;
      left: 1.5rem;
      z-index: 9999;
      transform: translateY(-50%);
    }
    .input {
      width: 90%;
      height: 2.2rem;
      padding-left: 2.6rem;
      border: none;
      position: relative;
      left: 50%;
      transform: translate(-50%);
    }
  }

  .title {
    text-align: left;
    font-size: 1.1rem;
    font-weight: bold;
    background-color: #f5f5f5;
    padding: 0 1rem;
  }
}
.AA {
  background: url('https://res.miaocode.com/zhanghongjie/usa-1649906752047.png') no-repeat center left;
  background-size: 100%;
}
.Macao {
  background: url('https://res.miaocode.com/zhanghongjie/am-1649906732882.png') no-repeat center left;
  background-size: 100%;
}
.HongKong {
  background: url('https://res.miaocode.com/zhanghongjie/xg-1649906745529.png') no-repeat center left;
  background-size: 100%;
}
.BL {
  background-position: 0 0;
}
.BM {
  background-position: 0 -32px;
}
.BN,
.BRU {
  background-position: 0 -64px;
}
.BO {
  background-position: 0 -96px;
}
.BR,
.BRD,
.BRA {
  background-position: 0 -128px;
}
.BS {
  background-position: 0 -160px;
}
.BT {
  background-position: 0 -192px;
}
.BW,
.BWA {
  background-position: 0 -224px;
}
.BY,
.BLR {
  background-position: 0 -256px;
}
.BZ {
  background-position: 0 -288px;
}
.CA,
.CAD,
.CAN {
  background-position: 0 -320px;
}
.CC {
  background-position: 0 -352px;
}
.CD,
.COD {
  background-position: 0 -384px;
}
.CF {
  background-position: 0 -416px;
}
.CG {
  background-position: 0 -448px;
}
.CH,
.CHF,
.CHE {
  background-position: 0 -480px;
}
.CI,
.CIV {
  background-position: 0 -512px;
}
.CK {
  background-position: 0 -544px;
}
.CL {
  background-position: 0 -576px;
}
.CM,
.CMR {
  background-position: 0 -608px;
}
.CN,
.CNY,
.CHN {
  background-position: 0 -640px;
}
.CO,
.COL {
  background-position: 0 -672px;
}
.CR,
.CRI {
  background-position: 0 -704px;
}
.CU {
  background-position: 0 -736px;
}
.CV {
  background-position: 0 -768px;
}
.CW {
  background-position: 0 -800px;
}
.CX {
  background-position: 0 -832px;
}
.CY {
  background-position: 0 -864px;
}
.CZ,
.CZK,
.CZE {
  background-position: 0 -896px;
}
.DE,
.DEU {
  background-position: 0 -928px;
}
.DJ {
  background-position: 0 -960px;
}
.DK,
.DKK,
.DNK {
  background-position: 0 -992px;
}
.DM {
  background-position: 0 -1024px;
}
.DO {
  background-position: 0 -1056px;
}
.DOLLAR {
  background-position: 0 -1088px;
}
.DZ,
.DZA {
  background-position: 0 -1120px;
}
.EC,
.ECU {
  background-position: 0 -1152px;
}
.EE,
.EST {
  background-position: 0 -1184px;
}
.EG,
.EGY {
  background-position: 0 -1216px;
}
.EH {
  background-position: 0 -1248px;
}
.ER {
  background-position: 0 -1280px;
}
.ES,
.ESP,
.SP {
  background-position: 0 -1312px;
}
.ET {
  background-position: 0 -1344px;
}
.EU,
.EUR {
  background-position: 0 -1376px;
}
.FI,
.FIN {
  background-position: 0 -1408px;
}
.FJ {
  background-position: 0 -1440px;
}
.FK {
  background-position: 0 -1472px;
}
.FM {
  background-position: 0 -1504px;
}
.FO {
  background-position: 0 -1536px;
}
.FR,
.FRA {
  background-position: 0 -1568px;
}
.GA {
  background-position: 0 -1600px;
}
.GB,
.EN,
.GBP,
.GBR {
  background-position: 0 -1632px;
}
.GD {
  background-position: 0 -1664px;
}
.GE,
.GEO {
  background-position: 0 -1696px;
}
.GG {
  background-position: 0 -1728px;
}
.GH,
.GHA {
  background-position: 0 -1760px;
}
.GI {
  background-position: 0 -1792px;
}
.GL {
  background-position: 0 -1824px;
}
.GM {
  background-position: 0 -1856px;
}
.GN {
  background-position: 0 -1888px;
}
.GOLD,
.gold {
  background-position: 0 -1920px;
}
.GQ {
  background-position: 0 -1952px;
}
.GR,
.GRC {
  background-position: 0 -1984px;
}
.GS {
  background-position: 0 -2016px;
}
.GT,
.GTM {
  background-position: 0 -2048px;
}
.GU {
  background-position: 0 -2080px;
}
.GW {
  background-position: 0 -2112px;
}
.GY {
  background-position: 0 -2144px;
}
.HK,
.HKD {
  background-position: 0 -2176px;
}
.HN {
  background-position: 0 -2208px;
}
.HR {
  background-position: 0 -2240px;
}
.HT {
  background-position: 0 -2272px;
}
.HU,
.HUF,
.HUN {
  background-position: 0 -2304px;
}
.IC {
  background-position: 0 -2336px;
}
.ID,
.IDR,
.IDN {
  background-position: 0 -2368px;
}
.IE {
  background-position: 0 -2400px;
}
.IL,
.ISR {
  background-position: 0 -2432px;
}
.IM {
  background-position: 0 -2464px;
}
.IN,
.INR,
.IND {
  background-position: 0 -2496px;
}
.IQ,
.IRQ {
  background-position: 0 -2528px;
}
.IR,
.IRN {
  background-position: 0 -2560px;
}
.IS,
.ISL {
  background-position: 0 -2592px;
}
.IT,
.ITA {
  background-position: 0 -2624px;
}
.JE {
  background-position: 0 -2656px;
}
.JM,
.JAM {
  background-position: 0 -2688px;
}
.JO,
.JOR {
  background-position: 0 -2720px;
}
.JP,
.JPY,
.JPN {
  background-position: 0 -2752px;
}
.KE,
.KEN {
  background-position: 0 -2784px;
}
.KG,
.KGZ {
  background-position: 0 -2816px;
}
.KH,
.KHM {
  background-position: 0 -2848px;
}
.KI {
  background-position: 0 -2880px;
}
.KM {
  background-position: 0 -2912px;
}
.KN {
  background-position: 0 -2944px;
}
.KP,
.KOR {
  background-position: 0 -2976px;
}
.KR,
.KRW {
  background-position: 0 -3008px;
}
.KW {
  background-position: 0 -3040px;
}
.KY {
  background-position: 0 -3072px;
}
.KK,
.KZ,
.KZT,
.KAZ {
  background-position: 0 -3104px;
}
.LA,
.LAO {
  background-position: 0 -3136px;
}
.LB {
  background-position: 0 -3168px;
}
.LC {
  background-position: 0 -3200px;
}
.LI {
  background-position: 0 -3232px;
}
.LK,
.LKA {
  background-position: 0 -3264px;
}
.LR {
  background-position: 0 -3296px;
}
.LS {
  background-position: 0 -3328px;
}
.LT,
.LTL,
.LTU {
  background-position: 0 -3360px;
}
.LU {
  background-position: 0 -3392px;
}
.LV,
.LVL,
.LVA {
  background-position: 0 -3424px;
}
.LY,
.LBY {
  background-position: 0 -3456px;
}
.MA,
.MAR {
  background-position: 0 -3488px;
}
.MC {
  background-position: 0 -3520px;
}
.MD,
.MDA {
  background-position: 0 -3552px;
}
.ME {
  background-position: 0 -3584px;
}
.MF {
  background-position: 0 -3616px;
}
.MG {
  background-position: 0 -3648px;
}
.MH {
  background-position: 0 -3680px;
}
.MK {
  background-position: 0 -3712px;
}
.ML {
  background-position: 0 -3744px;
}
.MM {
  background-position: 0 -3776px;
}
.MN,
.MNG {
  background-position: 0 -3808px;
}
.MO {
  background-position: 0 -3840px;
}
.MP {
  background-position: 0 -3872px;
}
.MQ {
  background-position: 0 -3904px;
}
.MR {
  background-position: 0 -3936px;
}
/*.MS { background-position: 0 -3968px; }*/
.MT {
  background-position: 0 -4000px;
}
.MU,
.MRI {
  background-position: 0 -4032px;
}
.MV,
.MDV {
  background-position: 0 -4064px;
}
.MW {
  background-position: 0 -4096px;
}
.MX,
.MXN,
.MEX {
  background-position: 0 -4128px;
}
.MY,
.MYR,
.MYS,
.MS {
  background-position: 0 -4160px;
}
.MZ {
  background-position: 0 -4192px;
}
.NA,
.NAM {
  background-position: 0 -4224px;
}
.NC {
  background-position: 0 -4256px;
}
.NE {
  background-position: 0 -4288px;
}
.NF {
  background-position: 0 -4320px;
}
.NG,
.NGN,
.NGR {
  background-position: 0 -4352px;
}
.NI {
  background-position: 0 -4384px;
}
.NL,
.NED {
  background-position: 0 -4416px;
}
.NO,
.NOK,
.NOR {
  background-position: 0 -4448px;
}
.NP {
  background-position: 0 -4480px;
}
.NR {
  background-position: 0 -4512px;
}
.NU {
  background-position: 0 -4544px;
}
.NZ,
.NZD,
.NZL {
  background-position: 0 -4576px;
}
.OM,
.OMR {
  background-position: 0 -4608px;
}
.PA,
.PAN {
  background-position: 0 -4640px;
}
.PE,
.PER {
  background-position: 0 -4672px;
}
.PF {
  background-position: 0 -4704px;
}
.PG {
  background-position: 0 -4736px;
}
.PH,
.PHL {
  background-position: 0 -4768px;
}
.PK,
.PAK {
  background-position: 0 -4800px;
}
.PL,
.PLN,
.POL {
  background-position: 0 -4832px;
}
.PN {
  background-position: 0 -4864px;
}
.PR {
  background-position: 0 -4896px;
}
.PS,
.PSE {
  background-position: 0 -4928px;
}
.PT,
.PRT {
  background-position: 0 -4960px;
}
.PW {
  background-position: 0 -4992px;
}
.PY,
.PRY {
  background-position: 0 -5024px;
}
.QA,
.QAR {
  background-position: 0 -5056px;
}
.RO,
.ROU {
  background-position: 0 -5088px;
}
.RS,
.SRB {
  background-position: 0 -5120px;
}
.RU,
.RUB,
.RUR,
.RUS {
  background-position: 0 -5152px;
}
.RW {
  background-position: 0 -5184px;
}
.SA,
.SAR,
.SAU {
  background-position: 0 -5216px;
}
.SB {
  background-position: 0 -5248px;
}
.SC {
  background-position: 0 -5280px;
}
.SD,
.SDN {
  background-position: 0 -5312px;
}
.SE,
.SEK,
.SWE {
  background-position: 0 -5344px;
}
.SG,
.SGD,
.SGP {
  background-position: 0 -5376px;
}
.SH {
  background-position: 0 -5408px;
}
.SI,
.SVN {
  background-position: 0 -5440px;
}
.SILVER,
.silver {
  background-position: 0 -5472px;
}
.SK,
.SVK {
  background-position: 0 -5504px;
}
.SL {
  background-position: 0 -5536px;
}
.SM {
  background-position: 0 -5568px;
}
.SN {
  background-position: 0 -5600px;
}
.SO {
  background-position: 0 -5632px;
}
.SR {
  background-position: 0 -5664px;
}
.SS {
  background-position: 0 -5696px;
}
.ST {
  background-position: 0 -5728px;
}
.SV,
.SLV {
  background-position: 0 -5760px;
}
.SY {
  background-position: 0 -5792px;
}
.SZ {
  background-position: 0 -5824px;
}
.TC {
  background-position: 0 -5856px;
}
.TD {
  background-position: 0 -5888px;
}
.TF {
  background-position: 0 -5920px;
}
.TG {
  background-position: 0 -5952px;
}
.TH,
.THA {
  background-position: 0 -5984px;
}
.TJ,
.TJK {
  background-position: 0 -6016px;
}
.TK {
  background-position: 0 -6048px;
}
.TL {
  background-position: 0 -6080px;
}
.TM,
.TKM {
  background-position: 0 -6112px;
}
.TN,
.TUN {
  background-position: 0 -6144px;
}
.TO {
  background-position: 0 -6176px;
}
.TR,
.TUR {
  background-position: 0 -6208px;
}
.TT,
.TTO {
  background-position: 0 -6240px;
}
.TV {
  background-position: 0 -6272px;
}
.TW,
.TWD {
  background-position: 0 -6304px;
}
.TZ {
  background-position: 0 -6336px;
}
.UA,
.UAH,
.UKR {
  background-position: 0 -6368px;
}
.UG,
.UGA {
  background-position: 0 -6400px;
}
.US,
.USD {
  background-position: 0 -6432px;
}
.UY {
  background-position: 0 -6464px;
}
.UZ,
.OZ,
.UZB {
  background-position: 0 -6496px;
}
.VA {
  background-position: 0 -6528px;
}
.VC {
  background-position: 0 -6560px;
}
.VE,
.VEN {
  background-position: 0 -6592px;
}
.VG {
  background-position: 0 -6624px;
}
/*.VI { background-position: 0 -6656px; }*/
.VN,
.VNM,
.VI {
  background-position: 0 -6688px;
}
.VU {
  background-position: 0 -6720px;
}
.WF {
  background-position: 0 -6752px;
}
.WS {
  background-position: 0 -6784px;
}
.YE,
.YEM {
  background-position: 0 -6816px;
}
.YT {
  background-position: 0 -6848px;
}
.ZA,
.ZAR,
.ZAF {
  background-position: 0 -6880px;
}
.ZM,
.ZMB {
  background-position: 0 -6912px;
}
.ZW,
.ZWE {
  background-position: 0 -6944px;
}
.AD {
  background-position: 0 -7584px;
}
.AE,
.AED,
.ARE,
.AR {
  background-position: 0 -7616px;
}
.AF,
.AFG {
  background-position: 0 -7648px;
}
.AG {
  background-position: 0 -7680px;
}
.AI {
  background-position: 0 -7712px;
}
.AL {
  background-position: 0 -7744px;
}
.AM,
.ARM {
  background-position: 0 -7776px;
}
.AN {
  background-position: 0 -7808px;
}
.AO {
  background-position: 0 -7840px;
}
.AQ {
  background-position: 0 -7872px;
}
.ARG {
  background-position: 0 -7904px;
}
.AS {
  background-position: 0 -7936px;
}
.AT,
.AUT {
  background-position: 0 -7968px;
}
.AU,
.AUD,
.AUS {
  background-position: 0 -8000px;
}
.AW {
  background-position: 0 -8032px;
}
.AX {
  background-position: 0 -8064px;
}
.AZ,
.AZE {
  background-position: 0 -8096px;
}
.BA,
.BIH {
  background-position: 0 -8128px;
}
.BB {
  background-position: 0 -8160px;
}
.BD,
.BGD {
  background-position: 0 -8192px;
}
.BE,
.BEL {
  background-position: 0 -8224px;
}
.BF {
  background-position: 0 -8256px;
}
.BG,
.BGN,
.BGR {
  background-position: 0 -8288px;
}
.BH,
.BHD,
.BRN {
  background-position: 0 -8320px;
}
.BI {
  background-position: 0 -8352px;
}
.BJ {
  background-position: 0 -8384px;
}
</style>



// WEBPACK FOOTER //
// src/components/country-select/getFlagDom.vue